import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";

export default function Register() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [gender, setGender] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await register(name, email, password, gender || null);
            toast.success("Welcome to WTA — 100 starter coins added");
            nav("/feed");
        } catch (err) {
            toast.error(formatErr(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-wta-bg text-white grid md:grid-cols-2">
            <div className="hidden md:block relative overflow-hidden">
                <img src="https://images.unsplash.com/photo-1763889784402-5e8744af31b2" alt="" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-r from-wta-bg via-wta-bg/40 to-transparent" />
                <div className="relative p-12 h-full flex flex-col justify-end">
                    <div className="font-heading text-xs tracking-[0.4em] text-wta-accent">JOIN THE ARENA</div>
                    <h1 className="font-heading text-6xl tracking-tight uppercase mt-4">Make Your<br />Mark.</h1>
                </div>
            </div>
            <div className="flex items-center justify-center p-6 md:p-12">
                <form onSubmit={onSubmit} className="w-full max-w-sm">
                    <Link to="/" className="inline-block">
                        <img src="/wta-logo.png" alt="World Talent Arena" className="h-14 w-auto" />
                    </Link>
                    <h2 className="font-heading text-4xl tracking-tight uppercase mt-10">Sign up</h2>
                    <p className="text-wta-muted text-sm mt-1">Free. Get 100 coins to start competing.</p>

                    <div className="mt-8 space-y-4">
                        <div>
                            <label className="text-xs tracking-widest text-wta-muted uppercase">Name</label>
                            <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)} className="mt-1 w-full bg-wta-surface border border-wta-border rounded-sm px-4 py-3 text-sm" />
                        </div>
                        <div>
                            <label className="text-xs tracking-widest text-wta-muted uppercase">Email</label>
                            <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full bg-wta-surface border border-wta-border rounded-sm px-4 py-3 text-sm" />
                        </div>
                        <div>
                            <label className="text-xs tracking-widest text-wta-muted uppercase">Password</label>
                            <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full bg-wta-surface border border-wta-border rounded-sm px-4 py-3 text-sm" />
                        </div>
                        <div>
                            <label className="text-xs tracking-widest text-wta-muted uppercase">Gender (optional, required for modeling competitions)</label>
                            <select data-testid="register-gender" value={gender} onChange={(e) => setGender(e.target.value)} className="mt-1 w-full bg-wta-surface border border-wta-border rounded-sm px-4 py-3 text-sm">
                                <option value="">Prefer not to say</option>
                                <option value="female">Female</option>
                                <option value="male">Male</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                    </div>

                    <button data-testid="register-submit" type="submit" disabled={loading} className="mt-6 w-full btn-primary py-3 rounded-sm text-base disabled:opacity-50">
                        {loading ? "..." : "Create account"}
                    </button>
                    <div className="text-sm text-wta-muted mt-6 text-center">
                        Already have one?{" "}
                        <Link to="/login" data-testid="goto-login" className="text-wta-primary hover:underline">Log in</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
